import { render } from "./PanelFirmasView.vue?vue&type=template&id=f94c8106"
import script from "./PanelFirmasView.vue?vue&type=script&lang=js"
export * from "./PanelFirmasView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__